import React from 'react';
import { Card, Avatar, Typography, Space, Tag } from 'antd';
import { UserOutlined, MedicineBoxOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

const DoctorCard = ({ doctor, actions }) => {
  return (
    <Card
      size="small"
      hoverable={!!actions}
      actions={actions}
      style={{ height: '100%' }}
    >
      <Card.Meta
        avatar={
          <Avatar
            size={48}
            src={doctor.avatar}
            icon={!doctor.avatar && <UserOutlined />}
            style={{ backgroundColor: doctor.avatar ? 'transparent' : '#52c41a' }}
          />
        }
        title={
          <Space direction="vertical" size={0}>
            <Text strong>
              {doctor.name || `${doctor.first_name} ${doctor.last_name}`}
            </Text>
            {doctor.category_name && (
              <Text type="secondary" style={{ fontSize: 12 }}>
                <MedicineBoxOutlined /> {doctor.category_name}
              </Text>
            )}
          </Space>
        }
        description={
          <Space direction="vertical" size="small" style={{ marginTop: 8 }}>
            {doctor.email && (
              <Text ellipsis style={{ fontSize: 12 }}>
                <MailOutlined /> {doctor.email}
              </Text>
            )}
            {doctor.phone && (
              <Text style={{ fontSize: 12 }}>
                <PhoneOutlined /> {doctor.phone}
              </Text>
            )}
            {doctor.consultations_count !== undefined && (
              <Tag color="blue" style={{ marginTop: 4 }}>
                {doctor.consultations_count} consultations
              </Tag>
            )}
          </Space>
        }
      />
    </Card>
  );
};

export default DoctorCard;